import WorkHistoryItem from "./WorkHistoryItem";

export default WorkHistoryItem;
